<ng-content></ng-content>
<cm-inspector-section>
    <ng-container cm-title> Parameters </ng-container>
    <ng-container cm-content>
        @for (key of $parameterKeys(); track key) {
            <cm-value-slot [node]="$node()" [key]="$any(key)" [label]="getLabel(key)"></cm-value-slot>
        }
    </ng-container>
</cm-inspector-section>
